import { PropTypes } from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { utils } from '../utils'
import { ActionProd_Size_Filter, ActionProd_Sort } from '../store/action/action-product'
import {  FormControl, InputLabel, MenuItem, Paper, Select } from '@material-ui/core'


class Filter extends Component {

    render() {

        // const { classes } = this.props;
        // console.log('classes.selectEmpty:', classes.selectEmpty)
        const style1 = {
            minWidth: '7rem',
            // marginBottom: '2rem',
            // marginTop: '-1.5rem',
        }
        return (
            <Paper >
                <div className='filter'>
                    <div className="filter-result">
                        {this.props.filterProducts?.length || 0} Products
                    </div>
                    <div className="filter-sort">


                        {/* FILTER SORT */}
                        <FormControl variant="outlined" className='formControl' style={style1} >
                            <InputLabel id="slLblOrder">Order</InputLabel>
                            <Select
                                labelId="slLblOrderId"
                                id="slOrderId"
                                value={this.props.sort}
                                onChange={(e) => this.props.ActionProd_Sort(e.target.value)}
                            >
                                {
                                    Object.keys(utils.constants.order).map((v) => (
                                        <MenuItem key={v} value={v}>{v}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                    </div>
                    <div className="filter-size">

                        {/* FILTER SIZE */}
                        <FormControl variant="outlined" className='formControl' style={style1} >
                            <InputLabel id="demo-simple-select-label">Size</InputLabel>
                            <Select
                                labelId="lblSize"
                                id="stSize"
                                value={this.props.size}
                                onChange={(e) => this.props.ActionProd_Size_Filter(this.props.products, e.target.value)}
                            >
                                {/* <MenuItem value=''>ALL</MenuItem> */}
                                {
                                    utils.constants.cSizes.map((v) => (
                                        <MenuItem key={v} value={v}>{v}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                    </div>
                </div>
            </Paper>
        )
    }
}

Filter.propTypes = {
    size: PropTypes.string,
    sort: PropTypes.string,
    products: PropTypes.any,
    filterProducts: PropTypes.any,
    classes: PropTypes.object,

    ActionProd_Size_Filter: PropTypes.func.isRequired,
    ActionProd_Sort: PropTypes.func.isRequired,
}

export default

    connect(
        (state) => ({
            products: state.reducer_product.products,
            size: state.reducer_product.size,
            sort: state.reducer_product.sort,
            filterProducts: state.reducer_product.filterProducts,
            // classes:withStyles(styles)
        }),
        {
            ActionProd_Size_Filter,
            ActionProd_Sort,
        })(Filter)





